// removed by extract-text-webpack-plugin
module.exports = {"boxes":"_34ODwjCGmwdqX_t53GyHiy"};


//////////////////
// WEBPACK FOOTER
// /www/client/src/components/TechnicalPage/Routes/Routes.scss
// module id = 994
// module chunks = 0